import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from '../locales/en.json';
import deTranslations from '../locales/de.json';

const resources = {
  en: {
    translation: enTranslations
  },
  de: {
    translation: deTranslations
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,

    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },

    // Supported languages (German variants)
    supportedLngs: ['en', 'de'],
    nonExplicitSupportedLngs: true,

    interpolation: {
      escapeValue: false // React already does escaping
    },

    // Custom language detection for German variants
    load: 'languageOnly'
  });

// Custom language detection for German variants
const originalDetector = i18n.services.languageDetector.detect;
i18n.services.languageDetector.detect = function(this: any, ...args: any[]) {
  const detected = originalDetector.apply(this, args);
  
  // Handle German language variants
  if (typeof detected === 'string') {
    if (detected.startsWith('de')) {
      return 'de';
    }
  }
  
  return detected;
};

export default i18n; 